import request from '@/utils/request'

/**
 * 公共接口表接口API
 */

const api = {
  /**
     * 获取地区树
     * @param {*} data
     * @returns
     */
  getAreaTree(data) {
    return request({
      url: `admin/index/areaTreeList`,
      method: 'post',
      data
    })
  },
  /**
     * 根据上级银行获取地区树
     * @param {*} data
     * @returns
     */
  getAreaList(data) {
    return request({
      url: `admin/index/getAreaList`,
      method: 'post',
      data
    })
  }
}

export default api
